export const summaryStyles = () => {
  const style = document.createElement('style');
  style.textContent = `   
/* 🔹 Summary Section Styling */
#summary {
    background: #2e3348; /* Dark greyish-blue background */
    color: #edf2f4;
    padding: 20px;
    margin-top: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
    font-size: 16px;
    line-height: 1.6;
    text-align: left;
    width: 100%;
   
  }
  
  /* 🔹 Summary Title */
  #summary h3 {
    color: #ff9f1c; /* Orange highlight */
    font-size: 20px;
    margin-bottom: 3px;
    font-weight: bold;
  }
  
  /* 🔹 Dense Summary Box */
 
  
  /* 🔹 Flex Layout for Key Stats */
  .summary-flex {
    display: flex;
    justify-content: space-between;
  }
  
  /* 🔹 Summary Item */
  .summary-item {
    padding: 4px 8px;
    border-radius: 4px;
    font-weight: bold;
  }
  
  /* 🔹 Pass/Fail Colors */
  .pass {
    background: #1b5e20;
    color: #a5d6a7;
  }
  .fail {
    background: #b71c1c;
    color: #ef9a9a;
  }
  
  /* 🔹 Failure Breakdown */
  .summary-details {
    font-size: 12px;
    color: #ff9f1c;
    text-align: center;
    display: flex;
    justify-content: space-around;
    padding: 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  /* 🔹 Failure Badges */
  .fail-badge {
    background: rgba(255, 0, 0, 0.1);
    padding: 3px 6px;
    border-radius: 4px;
  }
  
  /* 🔹 Session Status */
  .session-status {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    padding: 6px;
    border-radius: 4px;
  }
  
  /* 🔹 Status Colors */
  .session-status b {
    padding: 3px 8px;
    border-radius: 4px;
  }
    .summary-items{
    display:flex;
    align-items:center;
    justify-content:center;
    gap:12px;
    }
  
  #sessionStatus {
    background: #ff3d3d;
    color: white;
  }`;
  document.head.appendChild(style);
};
export const summaryUI = (event_pos) => {
  const { totalFail, totalPass } = getSummaryStats();

  let total = event_pos || 0;

  const template = ` <div id="summary">
      <h4>📊 Validation Summary</h4>
      <div class="summary-flex">
        <div class="summary-item">
          <span>Total:</span> <b id="validation_summary_totalEvents">${total}</b>
        </div>
        <div class="summary-items">
        <div class="summary-item pass">
          <span>✅ Passed:</span> <b id="passEvents">${totalPass}</b>
        </div>
        <div class="summary-item fail">
          <span>❌ Failed:</span> <b id="failEvents">${totalFail}</b>
        </div>
        </div>
      </div>

     
    </div>`;

  const summaryNode = document.getElementById('panel_summary_body');
  summaryNode.innerHTML = template;
};
const getSummaryStats = () => {
  const tablesBadges = document.querySelectorAll('.ect-badges');

  let totalPass = 0;
  let totalFail = 0;
  for (let badges of tablesBadges) {
    let esBadge = badges.children[0].dataset.esstatus === 'true';
    let upBadge = badges.children[1].dataset.cdstatus === 'true';
    let cdBadge = badges.children[2].dataset.upstatus === 'true';
    if (esBadge && upBadge && cdBadge) {
      totalPass++;
    } else {
      totalFail++;
    }
  }
  return {
    totalPass,
    totalFail,
  };
};
